import React, { useMemo, useState } from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade';
import { Image } from '../atoms/image'

interface IProps {
  index: number,
  openIndex: number | null
  imageName: string,
  title: string,
  description: string
  onClick: () => void
}

export const FullImageCard = (props: IProps) => {

  const isOpen = useMemo(() => props.index === props.openIndex, [props.index, props.openIndex])

  return (
    <Fade left duration={500} delay={props.index * 100} distance="40px">
      <div className="fullImageCard">
        <div className="fullImageCard--imageArea">
          <Image imageName={props.imageName} className="fullImageCard--imageArea__image" />
        </div>
        <div className="fullImageCard--descriptionArea">
          <div className="fullImageCard--descriptionArea--titleArea" onClick={props.onClick}>
            <p className="fullImageCard--descriptionArea--titleArea__title" translate='no'>{props.title}</p>
            <i className={`fas ${isOpen ? "fa-minus" : "fa-plus"}`} />
          </div>
          <div className={`fullImageCard--descriptionArea--imageArea ${isOpen && "fullImageCard--descriptionArea--imageArea__open"}`}>
            <Image imageName={props.imageName} className="fullImageCard--descriptionArea--imageArea__image" />
          </div>
          <p className={`fullImageCard--descriptionArea__description ${isOpen && "fullImageCard--descriptionArea__description__open"}`}>
            <p>{props.description}</p>
          </p>
        </div>
      </div>
    </Fade>
  )
}